import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLDivElement
  Args: {
    open?: boolean
    /* use this to turn off animation, make collapse/expand instant */
    static?: boolean
  }
  Blocks: {
    default: []
  }
}

/**
 * Nifty way to animate height 0 -> auto using grid
 *
 * Example with aria;
 * <button
 *  aria-expanded={{if this.isOpen "true" "false"}}
 *  aria-controls="my-content"
 *  {{on "click" this.open}}
 * >
 *   opener
 * </button>
 * <Collapser id="my-content" @open={{this.isOpen}}>
 *   hidden content
 * </Collapser>
 */
export const Collapser: TOC<Signature> = <template>
  <div
    class="grid
      {{if @open 'grid-rows-[1fr]' 'grid-rows-[0fr]'}}
      {{unless @static 'transition-[grid-template-rows] duration-300 ease-out'}}"
    ...attributes
  >
    <div class="overflow-hidden">
      {{yield}}
    </div>
  </div>
</template>
